<template>
  <div>
    <b-card
      border-variant="white"
      header-bg-variant="white"
      header-border-variant="muted"
      align="center"
      class="mt-5 border-0"
    >
      <b-card-body>
        <b-form class="login" @submit.prevent="login">
          <b-form-row>
            <b-col cols="6">
              <b-form-group>
                <input
                  size="md"
                  required
                  v-model="username"
                  type="text"
                  placeholder="Username"
                  class="shadow border-0 rounded p-2 my-3 text-muted"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <input
                  size="md"
                  required
                  v-model="password"
                  type="password"
                  placeholder="Password"
                  class="shadow border-0 rounded p-2 my-3"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row class="justify-content-center">
            <b-col cols="4">
              <b-button type="submit" variant="dark" block>
                Login
              </b-button>
            </b-col>
          </b-form-row>
        </b-form>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
    };
  },
  methods: {
    login: function() {
      let username = this.username;
      let password = this.password;
      this.$store
        .dispatch("login/login", { username, password })
        .then(() => {
          this.$router.push("/");
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>
